import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ID2XClientLoginResponse, ID2XClientTokenRefreshResponse } from "../interfaces/auth-api.interface";
import { TSocialLogin } from "../components/login/d2x-client-login-page/d2x-client-login-page.component";
import { Observable } from "rxjs";

export class AuthApi {

    constructor(private httpClient: HttpClient, private baseUrl: string) { }

    login(email: string, password: string, fcm_push_token: string): Observable<ID2XClientLoginResponse> {
        return this.httpClient.post<ID2XClientLoginResponse>(
            `${this.baseUrl}/v1/auth/login`,
            { email, password, fcm_push_token },
            { headers: { 'Content-Type': 'application/json' } }
        );
    }


    logout(refreshToken: string) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${refreshToken}`
        });

        return this.httpClient.post(
            `${this.baseUrl}/v1/auth/logout`,
            {}, // POST 요청이므로 body는 빈 객체로 보냅니다.
            { headers: headers, observe: 'response', responseType: 'text' }
        );
    }

    socialLogin(type: TSocialLogin) {
        return this.httpClient.get<{ login_url: string }>(`${this.baseUrl}/v1/auth/${type}/login?state=${encodeURIComponent(JSON.stringify({}))}`);
    }

    signIn(email: string, password: string) {
        return this.httpClient.post<{ detail: string }>(`${this.baseUrl}/v1/auth/send-verification-email`, { email, password })
    }

    sendResetPasswordEmail(email: string) {
        return this.httpClient.post<{ detail: string }>(`${this.baseUrl}/v1/auth/send-reset-password-email`, { email })
    }

    resetPassword(token: string, newPassword: string) {
        return this.httpClient.post<{ detail: string }>(`${this.baseUrl}/v1/auth/reset-password`, { token: token, password: newPassword })
    }


    /**
     * 리프레시 토큰으로 AccessToken을 갱신하는 메서드
     * @param refreshToken 현재 사용자의 리프레시 토큰
     * @returns 새로운 토큰을 포함하는 Observable
     */
    refreshToken(refreshToken: string): Observable<ID2XClientTokenRefreshResponse> {
        return this.httpClient.post<ID2XClientTokenRefreshResponse>(
            `${this.baseUrl}/v1/auth/token/refresh`,
            { refresh_token: refreshToken },
            { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) }
        );
    }

    /**
     * 세션 ID의 유효성을 검증하는 메서드
     * @param sessionId 현재 세션의 고유 ID
     * @returns 유효성 검사 결과 (true 또는 false)를 포함하는 Observable
     */
    validateSession(sessionId: string): Observable<boolean> {
        return this.httpClient.get<boolean>(
            `${this.baseUrl}/v1/auth/validate_session?session_id=${sessionId}`
        );
    }

}